<div class="table-scroll">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <!-- ID Column -->
        <ng-container [matColumnDef]="key" *ngFor="let key of displayedColumns">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{key}} </th>
            <td mat-cell *matCellDef="let row" [innerHTML]="row[key]"></td>
        </ng-container>

        <ng-container matColumnDef="actionsItems">
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">Actions</th>
            <td mat-cell *matCellDef="let row">
                <ng-container *ngTemplateOutlet="actionsItems; context: { $implicit: row }"></ng-container>
            </td>
        </ng-container>

        <!-- Optional per-column filter header cells (one per data column). Rendered only when the
             page supplies [columnFilters]; the filter row itself is hidden otherwise. -->
        <ng-container [matColumnDef]="key + '__filter'" *ngFor="let key of displayedColumns">
            <th mat-header-cell *matHeaderCellDef class="col-filter-cell">
                <ng-container *ngIf="columnFilters && columnFilters[key] as cfg">
                    <mat-form-field *ngIf="cfg.type === 'select'" appearance="outline" class="col-filter">
                        <mat-select [value]="filterState.columns[key] || ''"
                            (selectionChange)="setColumnFilter(key, $event.value)">
                            <mat-option value="">All</mat-option>
                            <mat-option *ngFor="let o of cfg.options" [value]="o">{{ o }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="cfg.type === 'text'" appearance="outline" class="col-filter">
                        <input matInput [value]="filterState.columns[key] || ''"
                            (keyup)="setColumnFilter(key, $any($event.target).value)" placeholder="Filter">
                    </mat-form-field>
                </ng-container>
            </th>
        </ng-container>
        <ng-container matColumnDef="actionsItems__filter">
            <th mat-header-cell *matHeaderCellDef class="col-filter-cell"></th>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let row" [attr.colspan]="columnsToDisplayWithExpand.length">
                <div class="example-element-detail" [@detailExpand]="row.isExpanded ? 'expanded' : 'collapsed'">
                    <ng-container *ngTemplateOutlet="expandedView; context: { $implicit: row }"></ng-container>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
        <tr mat-header-row *matHeaderRowDef="filterRowColumns" [class.d-none]="!columnFilters" class="filter-row"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplayWithExpand;" class="example-element-row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter</td>
        </tr>

    </table>
    <mat-paginator [pageSizeOptions]="[25, 50, 100]" [pageSize]="25" aria-label="Select page"></mat-paginator>
</div>